const colors = {
  white: '#fff',
  purple100: '#3c3c64',
  purple90: '#505074',
  purple80: '#636383',
  purpleTrans10: 'rgba(60, 60, 100, 0.1)',
  purpleTrans5: 'rgba(61, 64, 102, 0.05)',
};

export const scTheme = {
  primaryColor: '#67C1D5',
  primaryColorDarker: '#5BAABB',
  secondaryColor: '#3D4066',
  backgroundPrimary: '#E0E0E0',
  fontFamily: '"Work Sans", sans-serif',
  secondFont: "'Merriweather', serif",
  textColor: '#565A77',
  headingColor: '#312F4C',
  headingHoverColor: '#EC6657',
  formLabelColor: '#505050',
  errorColor: '#D60000',
  subHeadingColor: '#312F4C',
  listBgHoverColor: '#d6e4f1',
  logoHeight: '32px',
  categoryHeaderColor: '#327ab7',
  buttonTextColor: '#ffffff',
  buttonBorderRadius: '20px',
  formBackgroundColor: '#f6f6f6',
  pageBackgroundColor: '#fff',
  formIconColor: '#81839b',
  formFieldBg: 'rgba(0, 0, 0, 0.04)',
  formFieldBgHover: 'rgba(0, 0, 0, 0.08)',
  bp: {
    sm: '600px',
    md: '900px',
    lg: '1200px',
    xl: '1800px',
  },
  ...colors,
};
